import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import Social from './Social'

const HeaderHome = () => {

    const location = useLocation();

    return (
        <header id="header-home">
        <nav id="navbar">
          <div className="container">
               <ul>
                 <li><Link to="/" className={location.pathname === '/' ? 'current' : ''}>Home</Link></li>
                 <li><Link to="/work" className={location.pathname === '/work' ? 'current' : ''}>Work</Link></li>
                 <li><Link to="/about" className={location.pathname === '/about' ? 'current' : ''}>About</Link></li>
               </ul>
               </div>
             </nav>

             <div className="header-content">
               <div className="container">
               <h1>Aman Bhardwaj</h1>
               <Link to="/work" className="btn-dark">View My JavaScript Works</Link>
               <Social />
               </div>
             </div>

         </header>
    )
}

export default HeaderHome
